const DEFAULT_MESSAGE = "Al momento sembra che molti utenti stiano utilizzando Clara. Riprova tra qualche minuto.";

export class QuotaExceededError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "QuotaExceededError";
  }

  public static create(message: string = DEFAULT_MESSAGE): QuotaExceededError {
    return new QuotaExceededError(message);
  }

  public static withMessage(message: string): QuotaExceededError {
    return new QuotaExceededError(message);
  }

  public static fromError(error: Error): QuotaExceededError {
    return new QuotaExceededError(error.message);
  }

  public static isQuotaExceeded(eventData: string): boolean {
    const lowerCaseEventData = eventData.toLowerCase();

    const hasQuotaMessage =
      lowerCaseEventData.includes("quota exceeded") ||
      lowerCaseEventData.includes("assistantquotaexceedederror") ||
      lowerCaseEventData.includes("service quota") ||
      lowerCaseEventData.includes("throttling_exception") ||
      lowerCaseEventData.includes("service_quota_exceeded_exception");

    return hasQuotaMessage;
  }

  public static fromEventDataIfMatches(eventData: string, message?: string): QuotaExceededError | null {
    if (this.isQuotaExceeded(eventData)) {
      return new QuotaExceededError(message || "Quota exceeded");
    }
    return null;
  }

  public static isQuotaExceededError(error: unknown): error is QuotaExceededError {
    return error instanceof QuotaExceededError;
  }
}
